(() => {
  const root = document.querySelector('[data-softly-landing]');
  if (!root) return;

  const shell = root.querySelector('[data-softly-cart-shell]');
  const drawer = root.querySelector('[data-softly-cart-drawer]');
  const cartBody = root.querySelector('[data-softly-cart-body]');
  const cartFoot = root.querySelector('[data-softly-cart-foot]');
  const cartCount = root.querySelector('[data-softly-cart-count]');
  const cartSubtotal = root.querySelector('[data-softly-cart-subtotal]');
  const progressText = root.querySelector('[data-softly-cart-progress-text]');
  const progressBar = root.querySelector('[data-softly-cart-progress-bar]');
  const openButtons = root.querySelectorAll('[data-softly-cart-open]');
  const closeButtons = root.querySelectorAll('[data-softly-cart-close]');
  const offerTest = root.dataset.softlyOfferTest || 'control';
  const bundleDiscount = root.dataset.softlyBundleDiscount || 'SOFTLY2';
  let lastFocused = null;

  const money = (cents, currency = 'USD') => new Intl.NumberFormat('en-US', {
    style: 'currency', currency, minimumFractionDigits: 2,
  }).format(cents / 100);

  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };

  const updateCart = async (key, quantity) => {
    cartBody.setAttribute('aria-busy', 'true');
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!response.ok) throw new Error('Unable to update cart');
    renderCart(await response.json());
  };

  const renderCart = (cart) => {
    cartBody.replaceChildren();
    cartBody.setAttribute('aria-busy', 'false');
    cartCount.textContent = String(cart.item_count);
    cartCount.setAttribute('aria-label', `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'} in cart`);
    cartSubtotal.textContent = money(cart.total_price, cart.currency || 'USD');

    progressBar.style.width = '100%';
    progressText.textContent = 'Free shipping on every order';

    if (!cart.items.length) {
      cartFoot.hidden = true;
      const empty = element('div', 'softly__cart-empty');
      empty.append(element('div', 'softly__cart-empty-mark', 'S,N.'));
      empty.append(element('h3', '', 'Your ritual awaits.'));
      empty.append(element('p', '', 'Add The Smoothing Body Oil and begin your Soft Skin Era.'));
      const shop = element('button', '', 'SHOP THE OIL');
      shop.type = 'button';
      shop.addEventListener('click', () => {
        closeCart();
        document.querySelector('#shop')?.scrollIntoView({ behavior: 'smooth' });
      });
      empty.append(shop);
      cartBody.append(empty);
      return;
    }

    cartFoot.hidden = false;
    cart.items.forEach((item) => {
      const row = element('article', 'softly__cart-item');
      const image = element('img', 'softly__cart-item-image');
      image.src = item.image || '';
      image.alt = item.product_title || 'Softly product';
      image.width = 92;
      image.height = 116;
      row.append(image);

      const copy = element('div', 'softly__cart-item-copy');
      copy.append(element('h3', '', 'The Smoothing Body Oil'));
      copy.append(element('p', '', '150 ml / 5.07 fl oz'));
      const remove = element('button', 'softly__cart-remove', 'REMOVE');
      remove.type = 'button';
      remove.addEventListener('click', () => updateCart(item.key, 0).catch(showCartError));
      copy.append(remove);

      const bottom = element('div', 'softly__cart-item-bottom');
      const quantity = element('div', 'softly__cart-quantity');
      quantity.setAttribute('aria-label', 'Quantity');
      const minus = element('button', '', '−');
      minus.type = 'button';
      minus.setAttribute('aria-label', 'Decrease quantity');
      minus.addEventListener('click', () => updateCart(item.key, Math.max(0, item.quantity - 1)).catch(showCartError));
      const value = element('span', '', String(item.quantity));
      const plus = element('button', '', '+');
      plus.type = 'button';
      plus.setAttribute('aria-label', 'Increase quantity');
      plus.addEventListener('click', () => updateCart(item.key, item.quantity + 1).catch(showCartError));
      quantity.append(minus, value, plus);
      bottom.append(quantity, element('strong', 'softly__cart-line-price', money(item.final_line_price, cart.currency || 'USD')));
      copy.append(bottom);
      row.append(copy);
      cartBody.append(row);
    });
  };

  const showCartError = () => {
    cartBody.setAttribute('aria-busy', 'false');
    cartFoot.hidden = true;
    cartBody.replaceChildren();
    const notice = element('p', 'softly__cart-loading', 'Something went wrong. Please try again.');
    cartBody.prepend(notice);
  };

  const refreshCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  const openCart = async () => {
    lastFocused = document.activeElement;
    shell.hidden = false;
    document.body.classList.add('softly-cart-open');
    openButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
    drawer.focus();
    try { await refreshCart(); } catch (error) { showCartError(); }
  };

  const closeCart = () => {
    shell.hidden = true;
    document.body.classList.remove('softly-cart-open');
    openButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
    lastFocused?.focus?.();
  };

  openButtons.forEach((button) => button.addEventListener('click', openCart));
  closeButtons.forEach((button) => button.addEventListener('click', closeCart));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !shell.hidden) closeCart();
  });
  refreshCart().catch(() => {});

  const form = root.querySelector('[data-softly-product-form]');
  if (!form) return;

  const offerInputs = root.querySelectorAll('input[name="softly_offer"]');
  const quantityInput = form.elements.quantity;
  const sellingPlanInput = form.elements.selling_plan;
  const submitButton = form.querySelector('button[type="submit"]');

  const syncOffer = () => {
    const selected = root.querySelector('input[name="softly_offer"]:checked');
    if (!selected) return;
    quantityInput.value = selected.dataset.softlyQuantity || '1';
    const sellingPlan = selected.dataset.softlySellingPlan || '';
    sellingPlanInput.value = sellingPlan;
    sellingPlanInput.disabled = !sellingPlan;
    if (selected.value === 'bundle') submitButton.textContent = 'GET 2 FOR $119.98';
    else if (selected.value === 'subscription') submitButton.textContent = 'SUBSCRIBE & SAVE 25%';
    else submitButton.textContent = 'START YOUR SOFT SKIN ERA';
  };

  offerInputs.forEach((input) => input.addEventListener('change', syncOffer));
  syncOffer();

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = submitButton;
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'ADDING…';

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{
          id: Number(form.elements.id.value),
          quantity: Number(quantityInput.value || 1),
          ...(sellingPlanInput.disabled ? {} : { selling_plan: Number(sellingPlanInput.value) }),
        }] }),
      });
      if (!response.ok) throw new Error('Unable to add item');
      button.textContent = 'ADDED TO YOUR RITUAL';
      if (offerTest === 'bundle') {
        window.location.assign(`/discount/${encodeURIComponent(bundleDiscount)}?redirect=/checkout`);
        return;
      }
      if (offerTest === 'subscription') {
        window.location.assign('/checkout');
        return;
      }
      await openCart();
      window.setTimeout(() => {
        button.textContent = original;
        button.disabled = false;
      }, 1200);
    } catch (error) {
      button.textContent = 'PLEASE TRY AGAIN';
      button.disabled = false;
      window.setTimeout(() => { button.textContent = original; }, 1800);
    }
  });
})();
